import "vant/es/toast/style";
import _Toast from "vant/es/toast";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-3c3c8094"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "publish-form"
};
const _hoisted_2 = {
  class: "popup-header"
};
const _hoisted_3 = {
  class: "popup-title"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  class: "popup-body"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  class: "option-info"
};
const _hoisted_8 = {
  class: "option-name"
};
const _hoisted_9 = {
  class: "popup-footer"
};

const _hoisted_10 = /*#__PURE__*/_createTextVNode("确定");

const _hoisted_11 = {
  class: "popup-header"
};
const _hoisted_12 = {
  class: "popup-title"
};
const _hoisted_13 = ["onClick"];
const _hoisted_14 = {
  class: "popup-body"
};
const _hoisted_15 = ["onClick"];
const _hoisted_16 = {
  class: "option-info"
};
const _hoisted_17 = {
  class: "option-name"
};
const _hoisted_18 = {
  class: "popup-footer"
};
const _hoisted_19 = {
  key: 0,
  class: "footer-count"
};

const _hoisted_20 = /*#__PURE__*/_createTextVNode("确定");

const _hoisted_21 = {
  class: "popup-header"
};
const _hoisted_22 = {
  class: "popup-title"
};
const _hoisted_23 = ["onClick"];
const _hoisted_24 = {
  class: "popup-body picker-body"
};
const _hoisted_25 = {
  class: "popup-footer"
};

const _hoisted_26 = /*#__PURE__*/_createTextVNode("确定");

const _hoisted_27 = {
  key: 1,
  class: "popup-empty"
};

const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "暂无可选日期", -1));

import composition from '@/composition';
import { ref } from 'vue';
export default {
  setup(__props, {
    expose
  }) {
    const {
      request
    } = composition(); // 表单配置

    const formConfig = ref([]);
    const customFieldName = ref({
      text: 'content',
      value: 'id'
    });
    /**
     * 是否存在表单项
     */

    const hasForm = () => {
      return !!(formConfig.value && formConfig.value.length > 0);
    };
    /**
     * 获取表单配置
     * @param {number} tagId 话题id
     * @param {boolean} enabled 该话题是否配置了表单（isConfig == 1）
     */


    const getFormConfig = (tagId, enabled = true) => {
      if (!tagId || !enabled) {
        formConfig.value = [];
        return;
      }

      request.getConfigList(tagId).then(res => {
        formConfig.value = res.data.configList;

        for (let i = 0; i < formConfig.value.length; i++) {
          const cfg = formConfig.value[i];
          cfg.write = '';

          if (cfg.type == 2) {
            // 单选：拉取选项，使用 radio 弹窗
            cfg.showOption = false;
            cfg.radioValue = 0;
            cfg.optionCheckId = 0;
            cfg.option = [];
            request.getPickerList(cfg.id).then(r => {
              cfg.option = r.data;
            });
          }

          if (cfg.type == 4) {
            // 多选：拉取选项，使用 checkbox 弹窗
            cfg.showOption = false;
            cfg.checkboxValues = [];
            cfg.optionCheckIds = [];
            cfg.optionCheckId = '';
            cfg.option = [];
            request.getPickerList(cfg.id).then(r => {
              cfg.option = r.data;
            });
          }

          if (cfg.type == 5) {
            // 时间选择：根据后端 value + isIntradayOptional 计算可选日期
            cfg.showOption = false;
            cfg.selectedValue = 0;
            cfg.optionCheckId = '';
            cfg.pickerValue = null;
            cfg.dateOptions = computeDateOptions(cfg);
          }

          if (cfg.type == 3) {
            cfg.preview = [];
            cfg.imgList = [];
            cfg.uploadImg = [];
          }
        }
      });
    }; // 单选确认


    const confirmSingle = item => {
      const opt = item.option.find(o => o.id === item.radioValue);

      if (opt) {
        item.write = opt.content;
        item.optionCheckId = opt.id;
      }

      item.showOption = false;
    }; // 多选确认：将选中的多个选项 id 用逗号拼接


    const confirmMulti = item => {
      const selected = item.option.filter(o => item.checkboxValues.includes(o.id));
      item.optionCheckIds = selected.map(o => o.id);
      item.optionCheckId = item.optionCheckIds.join(',');
      item.write = selected.map(o => o.content).join(',');
      item.showOption = false;
    }; // 多选：点击整行切换选中态


    const toggleMulti = (item, optId) => {
      const values = item.checkboxValues;
      const idx = values.indexOf(optId);

      if (idx > -1) {
        values.splice(idx, 1);
      } else {
        values.push(optId);
      }
    }; // 时间选择：滚动时记录当前高亮日期


    const onDateChange = (item, val) => {
      item.pickerValue = Array.isArray(val) ? val[0] : val;
    }; // 时间选择确认


    const confirmDateClick = item => {
      const selected = item.pickerValue || item.dateOptions[0];
      if (!selected) return;
      item.write = selected.content;
      item.selectedValue = selected.id;
      item.optionCheckId = selected.id;
      item.showOption = false;
    };
    /**
     * 时间戳(ms) → YYYY-MM-DD 字符串
     * 用本地时间字段拼接，避免 toISOString() 带来的 UTC 偏移（东八区会差一天）
     * @param {number} ms
     * @returns {string}
     */


    const formatDateStr = ms => {
      const d = new Date(Number(ms));
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${y}-${m}-${day}`;
    };
    /**
     * 根据后端配置计算时间选择的可选日期列表
     * @param {object} cfg 表单项，需包含 value(开始#结束 时间戳) 与 isIntradayOptional(0|1)
     * @returns {Array<{id:number, content:string}>}
     */


    const DAY = 24 * 60 * 60 * 1000;

    const computeDateOptions = cfg => {
      if (!cfg.value || cfg.value.indexOf('#') === -1) return [];
      const parts = cfg.value.split('#');
      const backendStart = Number(parts[0]);
      const backendEnd = Number(parts[1]);
      if (!backendStart || !backendEnd) return []; // 以"今日0点"为基准，往后最多7日窗口

      const now = new Date();
      const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
      const windowStart = cfg.isIntradayOptional == 1 ? todayStart : todayStart + DAY;
      const windowEnd = windowStart + 6 * DAY; // 可选日期 = 后端范围 ∩ 7日窗口

      const earliest = Math.max(windowStart, backendStart);
      const latest = Math.min(windowEnd, backendEnd);
      if (earliest > latest) return [];
      const list = [];

      for (let d = earliest; d <= latest; d += DAY) {
        const dt = new Date(d);
        list.push({
          id: d,
          content: `${dt.getMonth() + 1}月${dt.getDate()}日`
        });
      }

      return list;
    }; // 图片上传超过最大限制


    const formOversize = () => {
      _Toast('上传单张图片超过10M');
    };
    /**
     * 表单校验：必填项未完成时直接 throw，由调用方捕获提示
     */


    const validate = () => {
      if (!hasForm()) return true;

      for (let i = 0; i < formConfig.value.length; i++) {
        const configItem = formConfig.value[i];

        if (configItem.isRequire == 1) {
          if (configItem.type == 1 && configItem.write.length < 1) {
            _Toast('请填写' + configItem.content);

            throw {
              message: '请填写' + configItem.content
            };
          } else if (configItem.type == 2 && configItem.optionCheckId == 0) {
            _Toast('请选择' + configItem.content);

            throw {
              message: '请填写' + configItem.content
            };
          } else if (configItem.type == 3 && configItem.preview.length < 1) {
            _Toast('请上传' + configItem.content);

            throw {
              message: '请填写' + configItem.content
            };
          } else if (configItem.type == 4 && (!configItem.optionCheckIds || configItem.optionCheckIds.length < 1)) {
            _Toast('请选择' + configItem.content);

            throw {
              message: '请选择' + configItem.content
            };
          } else if (configItem.type == 5 && !configItem.selectedValue) {
            _Toast('请选择' + configItem.content);

            throw {
              message: '请选择' + configItem.content
            };
          }
        }
      }

      return true;
    };
    /**
     * 提交表单配置，返回后端返回的 commitId
     * 后端判断选项超额时抛出错误（携带后端 msg），交由调用方展示
     */


    const commit = async () => {
      try {
        let commitJson = [];

        for (let i = 0; i < formConfig.value.length; i++) {
          const configItem = formConfig.value[i];

          if (configItem.type == 3) {
            configItem.uploadImg = [];

            for (let li = 0; li < configItem.preview.length; li++) {
              configItem.uploadImg.push(request.uploadFile(configItem.preview[li].file));
            }

            const res = await Promise.all(configItem.uploadImg);

            for (let t = 0; t < res.length; t++) {
              if (t == 0) {
                configItem.write = res[t].filePath;
              } else {
                configItem.write = configItem.write + ',' + res[t].filePath;
              }
            }
          }

          if (configItem.type == 4) {
            // 多选：选项 id 用逗号拼接上传
            commitJson[i] = {
              content: configItem.write,
              configId: configItem.id,
              tagId: configItem.tagId,
              optionsId: null,
              optionsIds: configItem.optionCheckIds,
              type: configItem.type
            };
            continue;
          }

          if (configItem.type == 5) {
            // 日期：选中的是时间戳，上传时转成 YYYY-MM-DD 字符串
            commitJson[i] = {
              content: configItem.selectedValue ? formatDateStr(configItem.selectedValue) : configItem.write,
              configId: configItem.id,
              tagId: configItem.tagId,
              optionsId: null,
              type: configItem.type
            };
            continue;
          }

          commitJson[i] = {
            content: configItem.write,
            configId: configItem.id,
            tagId: configItem.tagId,
            optionsId: configItem.optionCheckId ? configItem.optionCheckId : null,
            type: configItem.type
          };
        }

        const res = await request.configCommit(commitJson);
        return res.data;
      } catch (error) {
        return Promise.reject(error);
      }
    };

    expose({
      getFormConfig,
      validate,
      commit,
      hasForm
    });
    return (_ctx, _cache) => {
      const _component_van_field = _resolveComponent("van-field");

      const _component_van_icon = _resolveComponent("van-icon");

      const _component_van_radio = _resolveComponent("van-radio");

      const _component_van_radio_group = _resolveComponent("van-radio-group");

      const _component_van_button = _resolveComponent("van-button");

      const _component_van_popup = _resolveComponent("van-popup");

      const _component_van_checkbox = _resolveComponent("van-checkbox");

      const _component_van_checkbox_group = _resolveComponent("van-checkbox-group");

      const _component_van_picker = _resolveComponent("van-picker");

      const _component_van_uploader = _resolveComponent("van-uploader");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formConfig.value, (item, index) => {
        return _openBlock(), _createElementBlock(_Fragment, {
          key: index
        }, [item.type == 1 ? (_openBlock(), _createBlock(_component_van_field, {
          key: 0,
          modelValue: item.write,
          "onUpdate:modelValue": $event => item.write = $event,
          required: item.isRequire == 1,
          label: item.content,
          placeholder: "请填写"
        }, null, 8, ["modelValue", "onUpdate:modelValue", "required", "label"])) : _createCommentVNode("", true), item.type == 2 ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createVNode(_component_van_field, {
          required: item.isRequire == 1,
          "is-link": "",
          readonly: "",
          label: item.content,
          "model-value": item.write,
          placeholder: "请选择",
          onClick: $event => item.showOption = true
        }, null, 8, ["required", "label", "model-value", "onClick"]), _createVNode(_component_van_popup, {
          show: item.showOption,
          "onUpdate:show": $event => item.showOption = $event,
          round: "",
          position: "bottom",
          class: "option-popup",
          "lock-scroll": false
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", _hoisted_3, _toDisplayString(item.content), 1), _createElementVNode("div", {
            class: "popup-close",
            onClick: $event => item.showOption = false
          }, [_createVNode(_component_van_icon, {
            name: "cross",
            size: "13",
            color: "#999"
          })], 8, _hoisted_4)]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_van_radio_group, {
            modelValue: item.radioValue,
            "onUpdate:modelValue": $event => item.radioValue = $event
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.option, opt => {
              return _openBlock(), _createElementBlock("div", {
                key: opt.id,
                class: _normalizeClass(["option-card", {
                  selected: item.radioValue === opt.id
                }]),
                onClick: $event => item.radioValue = opt.id
              }, [_createElementVNode("div", _hoisted_7, [_createElementVNode("span", _hoisted_8, _toDisplayString(opt.content), 1)]), _createVNode(_component_van_radio, {
                name: opt.id,
                onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
              }, {
                icon: _withCtx(props => [_createElementVNode("span", {
                  class: _normalizeClass(["check-dot", {
                    checked: props.checked
                  }])
                }, [props.checked ? (_openBlock(), _createBlock(_component_van_icon, {
                  key: 0,
                  name: "success",
                  size: "11",
                  color: "#fff"
                })) : _createCommentVNode("", true)], 2)]),
                _: 2
              }, 1032, ["name"])], 10, _hoisted_6);
            }), 128))]),
            _: 2
          }, 1032, ["modelValue", "onUpdate:modelValue"])]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_van_button, {
            block: "",
            round: "",
            type: "primary",
            class: "confirm-btn",
            onClick: $event => confirmSingle(item)
          }, {
            default: _withCtx(() => [_hoisted_10]),
            _: 2
          }, 1032, ["onClick"])])]),
          _: 2
        }, 1032, ["show", "onUpdate:show"])], 64)) : _createCommentVNode("", true), item.type == 4 ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 2
        }, [_createVNode(_component_van_field, {
          required: item.isRequire == 1,
          "is-link": "",
          readonly: "",
          label: item.content,
          "model-value": item.write,
          placeholder: "请选择",
          onClick: $event => item.showOption = true
        }, null, 8, ["required", "label", "model-value", "onClick"]), _createVNode(_component_van_popup, {
          show: item.showOption,
          "onUpdate:show": $event => item.showOption = $event,
          round: "",
          position: "bottom",
          class: "option-popup",
          "lock-scroll": false
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_11, [_createElementVNode("span", _hoisted_12, _toDisplayString(item.content), 1), _createElementVNode("div", {
            class: "popup-close",
            onClick: $event => item.showOption = false
          }, [_createVNode(_component_van_icon, {
            name: "cross",
            size: "13",
            color: "#999"
          })], 8, _hoisted_13)]), _createElementVNode("div", _hoisted_14, [_createVNode(_component_van_checkbox_group, {
            modelValue: item.checkboxValues,
            "onUpdate:modelValue": $event => item.checkboxValues = $event
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.option, opt => {
              return _openBlock(), _createElementBlock("div", {
                key: opt.id,
                class: _normalizeClass(["option-card", {
                  selected: item.checkboxValues.includes(opt.id)
                }]),
                onClick: $event => toggleMulti(item, opt.id)
              }, [_createElementVNode("div", _hoisted_16, [_createElementVNode("span", _hoisted_17, _toDisplayString(opt.content), 1)]), _createVNode(_component_van_checkbox, {
                name: opt.id,
                onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
              }, {
                icon: _withCtx(props => [_createElementVNode("span", {
                  class: _normalizeClass(["check-dot square", {
                    checked: props.checked
                  }])
                }, [props.checked ? (_openBlock(), _createBlock(_component_van_icon, {
                  key: 0,
                  name: "success",
                  size: "11",
                  color: "#fff"
                })) : _createCommentVNode("", true)], 2)]),
                _: 2
              }, 1032, ["name"])], 10, _hoisted_15);
            }), 128))]),
            _: 2
          }, 1032, ["modelValue", "onUpdate:modelValue"])]), _createElementVNode("div", _hoisted_18, [item.checkboxValues.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_19, "已选 " + _toDisplayString(item.checkboxValues.length) + " 项", 1)) : _createCommentVNode("", true), _createVNode(_component_van_button, {
            block: "",
            round: "",
            type: "primary",
            class: "confirm-btn",
            onClick: $event => confirmMulti(item)
          }, {
            default: _withCtx(() => [_hoisted_20]),
            _: 2
          }, 1032, ["onClick"])])]),
          _: 2
        }, 1032, ["show", "onUpdate:show"])], 64)) : _createCommentVNode("", true), item.type == 5 ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 3
        }, [_createVNode(_component_van_field, {
          required: item.isRequire == 1,
          "is-link": "",
          readonly: "",
          label: item.content,
          "model-value": item.write,
          placeholder: "请选择",
          onClick: $event => item.showOption = true
        }, null, 8, ["required", "label", "model-value", "onClick"]), _createVNode(_component_van_popup, {
          show: item.showOption,
          "onUpdate:show": $event => item.showOption = $event,
          round: "",
          position: "bottom",
          class: "option-popup",
          "lock-scroll": false
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_21, [_createElementVNode("span", _hoisted_22, _toDisplayString(item.content), 1), _createElementVNode("div", {
            class: "popup-close",
            onClick: $event => item.showOption = false
          }, [_createVNode(_component_van_icon, {
            name: "cross",
            size: "13",
            color: "#999"
          })], 8, _hoisted_23)]), item.dateOptions.length ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createElementVNode("div", _hoisted_24, [_createVNode(_component_van_picker, {
            columns: item.dateOptions,
            "columns-field-names": customFieldName.value,
            "show-toolbar": false,
            onChange: $event => onDateChange(item, $event)
          }, null, 8, ["columns", "columns-field-names", "onChange"])]), _createElementVNode("div", _hoisted_25, [_createVNode(_component_van_button, {
            block: "",
            round: "",
            type: "primary",
            class: "confirm-btn",
            onClick: $event => confirmDateClick(item)
          }, {
            default: _withCtx(() => [_hoisted_26]),
            _: 2
          }, 1032, ["onClick"])])], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_27, [_createVNode(_component_van_icon, {
            name: "clock-o",
            size: "42",
            color: "#d8d8d8"
          }), _hoisted_28]))]),
          _: 2
        }, 1032, ["show", "onUpdate:show"])], 64)) : _createCommentVNode("", true), item.type == 3 ? (_openBlock(), _createBlock(_component_van_field, {
          key: 4,
          required: item.isRequire == 1,
          name: "uploader",
          label: item.content
        }, {
          input: _withCtx(() => [_createVNode(_component_van_uploader, {
            modelValue: item.preview,
            "onUpdate:modelValue": $event => item.preview = $event,
            "max-count": item.picSize,
            "max-size": 10 * 1024 * 1024,
            multiple: "",
            onOversize: formOversize
          }, null, 8, ["modelValue", "onUpdate:modelValue", "max-count"])]),
          _: 2
        }, 1032, ["required", "label"])) : _createCommentVNode("", true)], 64);
      }), 128))]);
    };
  }

};